import { CookieOptionsWithName } from "@supabase/ssr";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Cookie options for server and client
export const globalCookieOptions: CookieOptionsWithName = {
  name: "lewk-auth-token",
  sameSite: "lax",
  domain:
    process.env.NEXT_PUBLIC_NEXT_ENV === "development"
      ? "localhost"
      : ".shopthelewk.com",
  secure: process.env.NEXT_PUBLIC_NEXT_ENV !== "development",
};


/**
 * Uses FingerprintJS to generate a unique identifier for the user.
 * @returns visitorID
 */
export const getVisitorID = async (): Promise<string> => {
  //Load FingerprintJS
  const fp = await FingerprintJS.load();

  //Get visitor ID
  const result = await fp.get();

  // Return ID
  return result.visitorId;
};


export const pluralToSingular = (word: string): string => {
  if( word.endsWith('dressess')) {
    return "dress"
  }
  if (word.endsWith("ies")) {
    return word.slice(0, -3) + "y"; // cities -> city
  }
  if (word.endsWith("ves")) {
    return word.slice(0, -3) + "f"; // wolves -> wolf
  }
  if( word.endsWith('shoes')) {
    return "shoe"
  } //For now
  if (word.endsWith("oes")) {
    return word.slice(0, -2); // potatoes -> potato
  }
  if (word.endsWith("s") && !word.endsWith("ss")) {
    return word.slice(0, -1); // cats -> cat
  }
  return word; // If no rule applies, return the original word
};
